/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Logout Icon component.
 */
export const LogoutIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill={iconColor}>
      <path d='M18.2 11.75H8.75v.5h11.26l-1.28 1.28-2.07 2.07.34.34L20.94 12 17 8.06l-.34.34 2.07 2.07 1.28 1.28H18.2zm-14.2 8h-.75V4.25h8v-.5H4c-.686 0-1.25.564-1.25 1.25v14c0 .686.564 1.25 1.25 1.25h7.25v-.5H4z'
        stroke={iconColor}
        strokeWidth={1.5} />
    </svg>
  );
};
LogoutIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey3
};
